<div *ngFor="let error of errorCodes; let i = index">
  <div *ngIf="control?.hasError(error.code)" data-testid="error-label">
    {{ error.label(control?.getError(error.code)) }}
  </div>
</div>
